import { Component } from '@angular/core';
import {
  PersonDetailsFacadeService,
  UpdatePersonData,
} from '@qivos/qivoscloud-ion-components';
import { PersonDetailsForm } from '@qivos/qivoscloud-ion-components/lib/models/person-details.model';
import {
  Address,
  Consent,
  Email,
  Person,
  QivosCloudService,
} from '@qivos/qivoscloud-ng-api';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    public PersonFacade: PersonDetailsFacadeService,
    public qcService: QivosCloudService
  ) {}

  person = new Person();

  personDetails: PersonDetailsForm = {
    mobileNumber: {
      rendered: false,
      required: false,
      label: '',
      placeholder: '',
      value: '',
      validation: /^69[0-9]*\d*$/,
      message: '',
      disabled: true,
    },
    gender: {
      rendered: false,
      required: false,
      label: 'Προσφώνηση',
      maleGenderLabel: 'Κύριος',
      femaleGenderLabel: 'Κυρία',
      otherGenderLabel: 'Άλλο',
      value: { Name: '', Value: '' },
    },
    firstName: {
      rendered: false,
      required: false,
      disabled: false,
      label: 'Όνομα',
      placeholder: 'Πληκτρολόγησε το όνομά σου',
      value: '',
      validation: /^[α-ωίϊΐόάέύϋΰήώΑ-ΩΆΈΊΌΎΏΉa-zA-Zs.-]+$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    lastName: {
      rendered: false,
      required: false,
      disabled: false,
      label: 'Επώνυμο',
      placeholder: 'Πληκτρολόγησε το επώνυμό σου',
      value: '',
      validation: /^[α-ωίϊΐόάέύϋΰήώΑ-ΩΆΈΊΌΎΏΉa-zA-Zs.-]+$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    email: {
      rendered: true,
      required: true,
      label: 'Διεύθυνση Email',
      placeholder: 'Πληκτρολόγησε το email σου',
      value: '',
      validation:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@[A-Za-z0-9.-]{2,})+\.[A-Za-z]{2,}/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    region: {
      rendered: false,
      required: false,
      label: 'Νομός',
      placeholder: '',
      value: '',
      message: '',
    },
    town: {
      rendered: false,
      required: false,
      label: 'Πόλη',
      placeholder: '',
      value: '',
    },
    zipCode: {
      rendered: false,
      required: false,
      label: 'Τ.Κ.',
      placeholder: '',
      value: '',
      validation: /^[0-9]{5}$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    dateOfBirth: {
      rendered: false,
      required: false,
      label: 'Ημερομηνία γέννησης',
      placeholder: 'Ημερομηνία',
      datePickerDoneButtonLabel: 'OK',
      datePickerCancelButtonLabel: 'Άκυρο',
      value: '',
      minValue: 18,
      maxValue: 95,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    nameDate: {
      rendered: false,
      required: false,
      nameDateDayPlaceholder: 'Ημέρα',
      nameDateMonthPlaceholder: 'Μήνας',
      nameDateLabel: 'Ημερομηνία Ονομαστικής Εορτής',
      nameDateDayValue: '',
      nameDateDayLabel: 'Ημέρα',
      nameDateMonthValue: '',
      nameDateMonthLabel: 'Μήνας',
      errorMessage: 'Πρέπει να επιλέξεις πρώτα μήνα',
    },
    singleConsent: {
      rendered: false,
      required: false,
      label: '',
    },
    smsConsent: {
      rendered: false,
      label: 'Με SMS',
      value: false,
      name: 'SMS ',
    },
    viberConsent: {
      rendered: false,
      label: 'Με instant messages (Viber κλπ)',
      value: false,
      name: 'VIBER ',
    },
    emailConsent: {
      rendered: true,
      label: 'Συναινώ στη λήψη επικοινωνιών μέσω email',
      value: false,
      name: 'EMAIL_RADIANT',
    },
    multiConsent: {
      rendered: false,
      required: false,
      label: '',
    },
    allConsent: {
      rendered: false,
      label: 'Με όλα τα παραπάνω',
      value: false,
    },
    isPersonalized: true,
    token: '',
  };

  register() {
    if (this.PersonFacade.email.length > 0) {
      this.person.emailList?.push(
        new Email({ emailAddress: this.PersonFacade.email, isPrimary: true })
      );
    }

    if (this.PersonFacade.selectedRegionCode.length > 0) {
      this.person.addressList?.push(
        new Address({
          addressLine2: '',
          addressType: 'PRIMARY_PERSON_ADDRESS',
          town: this.PersonFacade.selectedTown,
          regionCode: this.PersonFacade.selectedRegionCode,
          countryCode: 'gr',
          postCode: this.PersonFacade.zipCode,
        })
      );
    }

    if (this.PersonFacade.multiConsentsStatus === false) {
      if (this.PersonFacade.smsConsent === true) {
        this.person.consentList?.push(
          new Consent({
            name: 'SMS',
            flag: true,
          })
        );
      }

      this.person.consentList?.push(
        new Consent({
          name: 'EMAIL_RADIANT',
          flag: this.PersonFacade.emailConsent === true ? true : false,
        })
      );

      if (this.PersonFacade.viberConsent === true) {
        this.person.consentList?.push(
          new Consent({
            name: 'VIBER',
            flag: true,
          })
        );
      }
    }

    if (this.PersonFacade.multiConsentsStatus === true) {
      this.person.consentList?.push(
        new Consent({
          name: 'SMS',
          flag: true,
        }),
        new Consent({
          name: 'EMAIL',
          flag: true,
        }),
        new Consent({
          name: 'VIBER',
          flag: true,
        })
      );
    }

    this.person.firstName = this.PersonFacade.firstName;
    this.person.lastName = this.PersonFacade.lastName;
    this.person.salutationCode = this.PersonFacade.gender.Value;
    this.person.gender = this.PersonFacade.gender.Value;
    this.person.dateOfBirth = this.PersonFacade.dateOfBirth;
    this.person.nameDayDay = this.PersonFacade.nameDateDay;
    this.person.nameDayMonth = this.PersonFacade.nameDateMonth;
    this.person.QCCode = this.PersonFacade.qcCode;

    this.PersonFacade.dispatch(UpdatePersonData({ person: this.person }));

    // this.PersonFacade.submitted$.subscribe((submitted) => {
    //   if (submitted) {
    //     this.PersonFacade.isDataUpdated$.subscribe((isDataUpdated) => {
    //       if (isDataUpdated) {
    //         window.location.href = 'https://www.google.com';
    //       } else {
    //         console.log('error');
    //       }
    //     });
    //   }
    // });
  }
}
